import saml2 from "saml2-js"
import { decodeSamlRedirect, xmlToJSON } from "./CommonUtils";
import { IAM_SSO_URL, SSO_ENTITY_ID, SSO_LOGIN_URL, SSO_LOGOUT_URL } from "./Config";
import { getLocalItem, getSessionItem } from "./storageUtils";
import { CC_PRODUCT_ID, IS_POD, NAME_ID, ROLE, SESSION_INDEX } from "./Constants";


const sp_options = {
    entity_id: SSO_ENTITY_ID,
    assert_endpoint: `${IAM_SSO_URL}/login`,
    // nameid_format: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress",
}
const sp = new saml2.ServiceProvider(sp_options);

const idp_options = {
    sso_login_url: SSO_LOGIN_URL,
    sso_logout_url: SSO_LOGOUT_URL
}
const idp = new saml2.IdentityProvider(idp_options);

export const authenticateUserSSO = () => {

const options = {
        relay_state: `${window.location.origin}`
}

    sp.create_login_request_url(idp, options, async (err, login_url) => {
        if (err != null)
            console.log("ERROR code: 500", login_url);
        else {
            // let samlReq = login_url.split("?SAMLRequest=",)[1]
            // setReqId(samlReq)
            window.location = login_url
        }
    });
}

export const ssoLogout = () => {
    const options = {
        name_id: getLocalItem(NAME_ID),
        session_index: getLocalItem(SESSION_INDEX)
    };

    sp.create_logout_request_url(idp, options, function (err, logout_url) {
        if (err != null)
            console.log("500", err)
        else
            window.location = logout_url;
    });
}

export const setReqId = (text) => {

    decodeSamlRedirect(text, (xml) => {
        const jsonText = xmlToJSON(xml);
        console.log("xmlText: ", jsonText);
        const reqId = jsonText?.attributes?.ID
        localStorage.setItem("reqId", reqId) //redux store
    })
}
